import http from '@/js/http';
import { SuccessResponse } from '@/types';

export const DocumentService = {
    async delete(id: string | number) {
        const { data } = await http.delete<SuccessResponse>(`/documents/${id}`);
        return data.success;
    },
};
